const API_URL = import.meta.env.VITE_API_URL || "http://localhost:3001";

export const RECIPE_ENDPOINTS = {
  BASE: `${API_URL}/recipes`,
  GET_ALL: `${API_URL}/recipes`,
  GET_BY_ID: (id: number) => `${API_URL}/recipes/${id}`,
  GET_BY_DIETS: (diets: string[]) => `${API_URL}/recipes?diets=${diets.join(",")}`,
} as const;

export default RECIPE_ENDPOINTS;
